import * as React from 'react';
import { useSelector } from 'react-redux';
import { formatExpirationDate, getTitle } from './utils';
import { selectBuyPackageModalData, selectIsSubscription } from '../../../../../../selectors/buyPackageModal';
import { ListItem } from '../ListItem';

export const ExpirationDateContainer = () => {
  const data = useSelector(selectBuyPackageModalData);
  const isSubscription = useSelector(selectIsSubscription);

  const { endDate, durationInDays } = data;

  const title = getTitle(isSubscription);

  return <ListItem title={title} content={formatExpirationDate({ endDate, durationInDays })} />;
};
